<template>
  <div>
    <bpb-dialog-opener
      class="styled-button styled-button--icon-left t-99"
      :target-id="`shop-dialog-${shopContext.itemId}`"
      :before-open-hook="addItemToCart"
    >
      <bpb-icon icon="i-cart" :decorative="true"></bpb-icon>
      <slot />
    </bpb-dialog-opener>
  </div>
</template>

<script>
export default {
  inject: ['formContext', 'shopContext'],
  methods: {
    async addItemToCart() {
      const amount = this.formContext.fields.amount;
      this.shopContext.setAmount(amount);

      setTimeout(() => {
        // um den nutzer nicht zu verwirren, lassen wir erst das
        // popup öffnen und setzen dann das feld zurück
        this.formContext.fields.amount = '1';
      }, 300);

      return await this.$store
        .dispatch('shopCart/add', {
          id: this.shopContext.itemId,
          amount: this.shopContext.amount,
        })
        .then(() => {
          return true;
        });
    },
  },
};
</script>
